import React, { useMemo } from 'react';
import { RoutesProvider, RoutesPaths, useRouterHelper } from '@shared/core';

export type RegistryRoute =
  | 'home'
  | 'build'
  | 'manage'
  | 'track'
  | 'catalog'
  | 'purchase'
  | 'bookmarklet'
  | 'quickAdd'
  | 'gettingStarted'
  | 'shopCatalog'
  | 'shopItem'
  | 'creditCardSetup'
  | 'addFromFriendsRegistry';

export const routePaths: RoutesPaths<RegistryRoute> = {
  home: {
    path: '',
    goToPath: () => '',
  },
  build: {
    path: 'build',
    goToPath: () => 'build',
  },
  manage: {
    path: 'manage',
    goToPath: () => 'manage',
  },
  track: {
    path: 'track',
    goToPath: () => 'track',
  },
  catalog: {
    path: 'shop',
    goToPath: () => 'shop',
  },
  purchase: {
    path: 'purchase',
    goToPath: () => 'purchase',
  },
  bookmarklet: {
    path: 'bookmarklet',
    goToPath: () => 'bookmarklet',
  },
  quickAdd: {
    path: 'get-quick-add-button',
    goToPath: () => 'quickAdd',
  },
  gettingStarted: {
    path: 'getting-started',
    goToPath: () => 'getting-started',
  },
  shopCatalog: {
    path: 'shop/catalog',
    goToPath: () => 'shop/catalog',
  },
  shopItem: {
    path: 'shop/item',
    goToPath: () => 'shop/item',
  },
  creditCardSetup: {
    path: 'credit-card/setup',
    goToPath: () => 'credit-card/setup',
  },
  addFromFriendsRegistry: {
    path: 'add-from-friends-registry',
    goToPath: () => 'add-from-friends-registry',
  },
};

export const useRoutePaths = () => {
  const { buildPath } = useRouterHelper();
  const memoizedPaths = useMemo(() => {
    return (Object.keys(routePaths) as RegistryRoute[]).reduce((acc, route) => {
      acc[route] = {
        path: buildPath(routePaths[route].path),
        goToPath: routePaths[route].goToPath,
      };
      return acc;
    }, {} as RoutesPaths<RegistryRoute>);
  }, [buildPath]);
  return memoizedPaths;
};

export const RegistryRouter: React.FC<{ eventHandle: string }> = ({ eventHandle, children }) => {
  return (
    <RoutesProvider
      handle={eventHandle}
      appUrl="registry"
    >
      {children}
    </RoutesProvider>
  );
};
